import { createRoute } from '@tanstack/react-router';
import { z } from 'zod/v4-mini';

import { NewPasswordPage } from '$/pages/Authentication/pages/NewPasswordPage';
import { RootRoute } from '$/routes/RootRoute';

const searchSchema = z.object({
  otp: z.union([z.string(), z.number()]),
  email: z.string().check(z.email()),
});

export const NewPasswordRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/new-password',
  component: NewPasswordPage,
  validateSearch: searchSchema,
});
